import React, { useEffect, useState } from "react";
import {
  compose,
  withStateHandlers,
  withHandlers,
  withPropsOnChange,
  branch,
  renderNothing,
  withState,
} from "recompose";
import { Button, Row, Col, Input, CustomInput } from "reactstrap";
import { LocalForm, Control, actions, Errors } from "react-redux-form";
import { Page, FormGroup, SaveButton, PendingButton } from "components/common";
import Dropzone from "react-dropzone";
import { NotificationManager } from "react-notifications";
import { Trans, withTranslation } from "react-i18next";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import validator from "validator";
import BackButton from "components/refactoring/BackButton";
import InvoiceLayoutSettingsModal from "components/InvoiceLayoutSettingsModal"
import { fetchZatcaApps } from "./Xero/AccountsReceivable/constants";
import Select from "react-select";
import { ZatcaClient } from "services";

export const isNumber = (v) =>
  validator.isFloat(`${v}`, { min: 0 }) &&
  validator.isDecimal(`${v}`, { decimal_digits: "0,2" });
const isInt = (v, options = { min: 0 }) => validator.isInt(`${v}`, options);

export const Settings = ({
  onDropAccepted,
  onSubmit,
  file,
  onDownload,
  onUpdate,
  onChange,
  form,
  item,
  setDispatch,
  onDisconnect,
  onLogoLoad,
  onLogoError,
  isAdmin,
  dispatch,
  t,
  onModalFormSubmit,
  isModalOpen,
  setIsModalOpen,
  invoiceLayoutSettings,
  setInvoiceLayoutSettings,
  contacts,
}) => {

  const [currentIndex, setCurrentIndex] = React.useState(null)
  const [zatcaApps, setZatcaApps] = useState();

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const zatca = ZatcaClient()

  useEffect(async () => {
    const _apps = await fetchZatcaApps(zatca)
    setZatcaApps(_apps)
  }, []);


  const onAddHandler = () => {
    let currentLength = invoiceLayoutSettings.length
    setCurrentIndex(currentLength)

    toggleModal()
  }

  const onEditHandler = (item, index) => {
    setCurrentIndex(index)

    toggleModal()
  }

  const onRemoveHandler = (item, index) => {
    invoiceLayoutSettings.splice(index, 1)
    setInvoiceLayoutSettings(invoiceLayoutSettings)

    setTimeout(() => {
      onModalFormSubmit()
    }, 100)
  }

  return (
    <Page title="Invoice Settings">
      <BackButton />
      <LocalForm
        onUpdate={onUpdate}
        onSubmit={onSubmit}
        initialState={item}
        onChange={onChange}
        getDispatch={setDispatch}
        validators={{
          margin_left: { isNumber },
          margin_top: { isNumber },
          margin_right: { isNumber },
          margin_bottom: { isNumber },
          font_size_base: { isInt },
          font_size_heading: { isInt },
        }}
      >

        <FormGroup model=".invoice_label" label="Invoice Label" className="py-2">
          <Control.text model=".invoice_label" />
        </FormGroup>
        <FormGroup model=".header" label="Company Details" className="pt-2 pb-2">
          <Control.textarea rows="4" model=".header" style={{ backgroundColor: '#F4F7FE' }} />
        </FormGroup>
        <FormGroup className="pt-2 pb-2"
          model=".footer_english"
          label="Terms & Payment Advice (English)"
        >
          <Control.textarea rows="4" model=".footer_english" style={{ backgroundColor: '#F4F7FE' }} />
        </FormGroup>
        <FormGroup model=".footer" label="Terms & Payment Advice (Arabic)" className="py-2">
          <Control.textarea rows="4" model=".footer" style={{ backgroundColor: '#F4F7FE' }} />
        </FormGroup>
        {
          isAdmin && (
            <>
              <FormGroup model=".name" label="Name" className="py-2">
                <Control.text rows="4" model=".name" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".vat_number" label="VAT Number">
                <Control.text model=".vat_number" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".registration_number" label="Registration Number">
                <Control.text model=".registration_number" type="Number" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".address" label="Address">
                <Control.textarea rows="4" model=".address" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".city" label="City">
                <Control.text model=".city" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".country" label="Country">
                <Control.text model=".country" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".region" label="Region">
                <Control.text model=".region" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup model=".postal_code" label="Postal Code">
                <Control.text model=".postal_code" style={{ backgroundColor: '#F4F7FE' }} type="number" />
              </FormGroup>
              <FormGroup model=".building_number" label="Building Number">
                <Control.text model=".building_number" style={{ backgroundColor: '#F4F7FE' }} type="number" />
              </FormGroup>
              <FormGroup model=".plot_number" label="Plot Number">
                <Control.text model=".plot_number" style={{ backgroundColor: '#F4F7FE' }} type="number" />
              </FormGroup>
            </>
          )
        }
        <FormGroup model=".invoices_counter" label="Invoice Counter">
          <Control.text model=".invoices_counter" type="Number" style={{ backgroundColor: '#F4F7FE' }} />
        </FormGroup>

        {!isAdmin && <FormGroup model=".zatca_phase_one_enabled" className="my-3">
          <CustomInput type="checkbox" onChange={(evt) => dispatch(actions.change('local.zatca_phase_one_enabled', evt.target.checked))} 
          checked={item.zatca_phase_one_enabled} label={t('Enable ZATCA Phase 1')} id ='zatca_phase_one_enabled' model='.zatca_phase_one_enabled'/>
        </FormGroup>}

        <div className="border p-2">
          <FormGroup model=".zatca_auto_send.enabled" className="my-3">
            <CustomInput type="checkbox" onChange={(evt) => dispatch(actions.change('local.zatca_auto_send.enabled', evt.target.checked))} 
            checked={item?.zatca_auto_send?.enabled} label={t('Zatca Auto Report')} id='zatca_auto_send.enabled' model='.zatca_auto_send.enabled'/>
          </FormGroup>
          <FormGroup model=".zatca_auto_send.app_id" className="my-3" addControlClass={false}>
            <Control.select
              component={Select}
              options={zatcaApps}
              searchable={false}
              simpleValue
              clearable={false}
              model=".zatca_auto_send.app_id"
            />
          </FormGroup>
        </div>

        {!isAdmin &&
          <Row>
              <Col className="col-12 py-2" >
                <FormGroup model=".pos_contact_ids" label="POS Contacts (Used to separate POS invoices from other invoices)" addControlClass={false}>
                  <Control.select
                    component={Select}
                    multi={true}
                    model=".pos_contacts_ids"
                    options={contacts}
                    simpleValue
                    labelKey="Name"
                    valueKey="ContactID" />
                </FormGroup>
              </Col>
          </Row>
        }

        <FormGroup label="Invoice Logo" model=".logo" className="pt-2 pb-2">
          <Dropzone
            multiple={false}
            className="border border-primary rounded"
            style={{ backgroundColor: '#F4F7FE' }}
            onDropAccepted={onDropAccepted}
          >
            <div className="m-2 text-center">
              {item.logo ? (
                <div>
                  <img
                    alt="logo"
                    onLoad={onLogoLoad}
                    onError={onLogoError}
                    className="img-thumbnail mb-3"
                    src={item.logo}
                    style={{ maxWidth: "200px" }}
                  />
                </div>
              ) : null}
              <span>
                <Trans>
                  Drop an image file here, or click to select a file to upload.
                </Trans>
              </span>
            </div>
          </Dropzone>
          {item.logo ? (
            <PendingButton
              className="mt-1"
              onClick={() => {
                dispatch(actions.change("local.logo", null));
              }}
            >
              Clear
            </PendingButton>
          ) : null}

          <Errors
            model=".logo"
            component={(props) => (
              <p className="form-text small text-danger" {...props} />
            )}
            messages={{
              invalid: t("This is not a valid image file"),
            }}
          />
        </FormGroup>
        <hr />
        <h4 style={{ fontWeight: 300 }}>
          <Trans>Invoice Margins (cm)</Trans>
        </h4>
        <Row>
          <Col>
            <FormGroup label="Left" model=".margin_left" className="py-2">
              <Control.text model=".margin_left" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Top" model=".margin_top" className="py-2">
              <Control.text model=".margin_top" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Right" model=".margin_right" className="py-2">
              <Control.text model=".margin_right" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Bottom" model=".margin_bottom" className="py-2">
              <Control.text model=".margin_bottom" />
            </FormGroup>
          </Col>
        </Row>
        <h4 style={{ fontWeight: 300 }}>
          <Trans>Invoice Font Size</Trans>
        </h4>
        <Row>
          <Col>
            <FormGroup label="Base" model=".font_size_base" className="py-2">
              <Control.text model=".font_size_base" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Heading" model=".font_size_heading" className="py-2">
              <Control.text model=".font_size_heading" />
            </FormGroup>
          </Col>
        </Row>

        {!isAdmin && <Row>
          <Col>
            <h5 className="mt-3"><Trans>{t('Invoice Layout Settings')}</Trans></h5>
            <hr />
            <div className="w-100 text-right">
              <Button color="primary" onClick={() => onAddHandler()}>
                <Trans>{t('Add New Settings')}</Trans>
              </Button>
            </div>

            <div className="w-100 justify-content-center my-2">
              <table className="table">
                <thead>
                  <tr>
                    <th><Trans>{t('Layout Name')}</Trans></th>
                    <th><Trans>{t('Font family')}</Trans></th>
                    <th><Trans>{t('Font size')}</Trans></th>
                    <th><Trans>{t('Font color')}</Trans></th>
                    <th><Trans>{t('Action')}</Trans></th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceLayoutSettings?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.layout?.replace(/_/g, ' ').toUpperCase()}</td>
                      <td>{item.font_family}</td>
                      <td>{item.font_size}</td>
                      <td>{item.font_color}</td>
                      <td>
                        <Button
                          color="primary"
                          onClick={() => onEditHandler(item, index)}
                        >
                          <Trans>{t('Edit')}</Trans>
                        </Button>
                        <Button
                          color="danger"
                          onClick={() => onRemoveHandler(item, index)}
                        >
                          <Trans>{t('Remove')}</Trans>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Input type="hidden" model=".invoice_layout_settings" value={invoiceLayoutSettings || []} />

            <InvoiceLayoutSettingsModal
              modal={isModalOpen}
              toggle={toggleModal}
              t={t}
              size="xl"
              fullscreen={true}
              centered={true}
              scrollable={true}
              submitHandler={onModalFormSubmit}
              data={(invoiceLayoutSettings && invoiceLayoutSettings[currentIndex]) || null}
              index={currentIndex}
              settings={item}

            />

          </Col>
        </Row>}

        {isAdmin && (
          <div>
            <hr />
            <h4 style={{ fontWeight: 300 }}>Invoice Email Template</h4>
            <div className="form-text text-muted small mt-1 mb-2">
              <Trans>
                The placeholders available for this email are: [Amount Due], [Due
                Date], [Invoice Number], [Invoice Total], [Reference], [Amount Due
                Without Currency], [Invoice Total Without Currency], [Contact
                Name], [Contact First Name], [Contact Last Name], [Currency Code],
                [Trading Name]
              </Trans>
            </div>
            <FormGroup model=".invoice_email_subject_template" label="Subject" className="py-2">
              <Control.text model=".invoice_email_subject_template" />
            </FormGroup>
            <FormGroup model=".invoice_email_content_template" label="Content" className="py-2">
              <Control.textarea
                rows="10"
                model=".invoice_email_content_template"
              />
            </FormGroup>
            <hr />
            <h4 style={{ fontWeight: 300 }}>Invoice Reminder Email Template</h4>
            <FormGroup className="py-2"
              model=".invoice_reminder_email_subject_template"
              label="Subject"
            >
              <Control.text model=".invoice_reminder_email_subject_template" />
            </FormGroup>
            <FormGroup className="py-2"
              model=".invoice_reminder_email_content_template"
              label="Content"
            >
              <Control.textarea
                rows="10"
                model=".invoice_reminder_email_content_template"
              />
            </FormGroup>
          </div>
        )}
        <hr />
        <div className="clearfix">
          <SaveButton className="float-right" form={form} />
        </div>
      </LocalForm>
    </Page>
  )
}

export const enhance = compose(
  withOrganisationContextConsumer,
  withTranslation(),
  withState("isModalOpen", "setIsModalOpen", false),
  withState("invoiceLayoutSettings", "setInvoiceLayoutSettings", []),
  withState("contacts", "setContacts", []),
  withStateHandlers(
    {},
    {
      onChange: () => (item) => ({ item }),
      onUpdate: () => (form) => ({ form }),
      setDispatch:
        ({ item }) =>
          (dispatch) => ({ dispatch }),
    }
  ),
  withPropsOnChange([], ({ xero, client, isAdmin, onChange, setInvoiceLayoutSettings, setContacts }) => {
    if (isAdmin) {
      client.get("global_settings").tap((resp) => {
        onChange(resp.data);
        setInvoiceLayoutSettings(resp.data?.invoice_layout_settings || [])
      });
    } else {
      xero.get("all/invoice_settings").tap((resp) => {
        onChange(resp.data);
        setInvoiceLayoutSettings(resp.data?.invoice_layout_settings || [])
      });
      xero.get("contacts").tap((resp) => {
        setContacts(resp.data || [])
      });
    }
  }),
  branch((props) => !props.item, renderNothing),
  withHandlers({
    onDropAccepted:
      ({ dispatch, setFile }) =>
        ([file]) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            dispatch(actions.change("local.logo", e.target.result));
          };
          reader.readAsDataURL(file);
        },
    onLogoError:
      ({ dispatch }) =>
        () => {
          dispatch(actions.setErrors("local.logo", { invalid: true }));
        },
    onLogoLoad:
      ({ dispatch }) =>
        (e) => {
          dispatch(actions.setErrors("local.logo", { invalid: false }));
        },

    onModalFormSubmit:
      ({ dispatch, item, isAdmin, xero, client, t, invoiceLayoutSettings, setInvoiceLayoutSettings, setIsModalOpen, clearContext }) =>
        (settingsItem = null, index = null) => {

          if (settingsItem) {
            invoiceLayoutSettings[index] = settingsItem
            setInvoiceLayoutSettings(invoiceLayoutSettings)
          }

          const tmpItem = item;

          const postData = {
            ...tmpItem,
            logo: tmpItem.logo || null,
            invoice_layout_settings: invoiceLayoutSettings,
          };

          (isAdmin
            ? client.patch(`global_settings/${postData.id}`, postData)
            : xero.patch(`all/invoice_settings`, postData)
          )
            .tap(() => {
              NotificationManager.success(t("Saved successfully"));
              if (!isAdmin) {
                clearContext("settings");
              }
            })
            .finally(() => {
              setIsModalOpen(false)
            });
        },
    onSubmit:
      ({ dispatch, xero, isAdmin, client, t, clearContext }) =>
        (tmpItem) => {
          dispatch(actions.setPending("local"));
          const item = {
            ...tmpItem,
            logo: tmpItem.logo || null,
          };

          (isAdmin
            ? client.patch(`global_settings/${item.id}`, item)
            : xero.patch(`all/invoice_settings`, item)
          )
            .tap(() => {
              NotificationManager.success(t("Saved successfully"));
              window.location.reload();
              if (!isAdmin) {
                clearContext("settings");
              }
            })
            .finally(() => dispatch(actions.setSubmitted("local")));
        },
  })
);

export default enhance(Settings);
